import * as React from "react";

export const OldLoading: React.FunctionComponent = () => {
    return (
      <React.Fragment>
        <div className="react-plp-loading__block react-plp-loading__block--is-active"></div>
        <div className="bbnt-gift-card-page-loading">
            <div className="loading-item-container">
                <div className="bbnt-cart-loading">
                    <div className='loader'></div>                    
                </div>
                <div className="loading-text">Loading Gift Card...</div>
            </div>
        </div>
      </React.Fragment>
    )
};

